var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import cookie from '../cookie/cookie';
import axios from 'axios';
import { getSign } from '@didi/wsgsig';
var request = axios.create();
request.defaults.baseURL = window.location.origin;
request.defaults.timeout = 20 * 1000;
request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// Add a response interceptor
request.interceptors.response.use(function (response) {
    // Do something with response data
    window.loading && window.loading.close();
    var data = response.data, config = response.config;
    if (response.headers['content-type'] === 'application/json; charset=utf-8') {
        if (data.errorCode === 'ESOCKETTIMEDOUT') {
            Vue.prototype.$message({
                message: '网络超时,请重试!',
                type: 'error',
                showClose: true,
            });
        }
        else if (data.errorCode !== 0 && data.errorCode !== 620 && data.errorCode !== 23000 && config.isShowNoLimit) {
            Vue.prototype.$message({
                message: data.errorMsg || 'Server error',
                type: 'error',
                showClose: true,
            });
            return data;
        }
        else if (data.errorCode === 23000 && config.isShowNoLimit) {
            Vue.prototype.$message({
                message: data.errorMsg || 'Server error',
                type: 'error',
                showClose: true,
            });
            return data;
        }
        else if (data.errorCode === 23000 && !config.isShowNoLimit) {
            data.errorCode = 0;
            return data;
        }
        else if (data.errorCode === 620) {
            cookie.setCookie({
                usernameZh: '',
                dafs_token: '',
            }, -1);
            Vue.prototype.$message({
                message: data.errorCode === 620 ? '登录失效，请重新登录' : '用户名或密码错误',
                type: 'error',
                showClose: true,
            });
            setTimeout(function () {
                window.location.reload();
            }, 500);
        }
        return data;
    }
}, function (err) {
    // Do something with response error
    window.loading && window.loading.close();
    Vue.prototype.$message.error(err || 'Server error');
});
export default function (url, data, method, headers, loadingControl, isShowNoLimit) {
    if (method === void 0) { method = 'get'; }
    if (loadingControl === void 0) { loadingControl = 'auto'; }
    if (isShowNoLimit === void 0) { isShowNoLimit = true; }
    var options = {};
    if (typeof url === 'object') {
        options = url;
        options.method = options.method || 'get';
        if (options.transformRequest && options.transformRequest instanceof Function) {
            options.transformRequest = [options.transformRequest];
        }
        options.needEncrypt = true;
        options.loadingControl = url.loadingControl || 'auto';
        options.isShowNoLimit = url.isShowNoLimit != null && url.isShowNoLimit != undefined ? url.isShowNoLimit : true;
    }
    else {
        options = {
            url: url,
            method: method,
            loadingControl: loadingControl,
            isShowNoLimit: isShowNoLimit,
            needEncrypt: true,
            data: data || {},
        };
    }
    if (options.method.toLowerCase() === 'get')
        options.params = options.data;
    if (options.loadingControl === 'auto') {
        window.loading = Vue.prototype.$loading({
            spinner: 'el-icon-loading',
            background: 'rgba(300, 300, 300, 0.5)',
            customClass: 'loading',
            body: true,
        });
    }
    // 调用sdk方法getSign
    var sign, result = { noDomainCheck: false };
    if (options.method === 'get') {
        if (options.params) {
            // 有params传params
            result['params'] = options.params;
            sign = getSign(result);
            options.headers = __assign({}, options.headers, { wsgsig: sign });
            console.log('get有params', result);
        }
    }
    if (options.method === 'post') {
        if (options.params) {
            // 有params
            result['params'] = options.params;
            if (options.body) {
                // 有body
                result['body'] = options.body;
                if (options.headers) {
                    result['contentType'] = options.headers['Content-Type'] || 'application/json';
                }
                else {
                    result['contentType'] = 'application/json';
                }
            }
            sign = getSign(result);
            options.headers = __assign({}, options.headers, { wsgsig: sign });
            console.log('post有params', result);
        }
        else {
            // 无params
            if (options.data) {
                // 有body
                result['body'] = options.data;
                if (options.headers) {
                    result['contentType'] = options.headers['Content-Type'] || 'application/json';
                }
                else {
                    result['contentType'] = 'application/json';
                }
                console.log(result);
                sign = getSign(result);
                options.headers = __assign({}, options.headers, { wsgsig: sign });
                console.log('post只有body', options, result);
            }
        }
    }
    return request(options);
}
